import { getDefaultExportFromCjs as a } from "./atoms-v2801.js";
import { _ as o } from "./atoms-v21160.js";
import { _ as i } from "./atoms-v21161.js";
var s = o, e = i, f = e(function(r, t) {
  return r == null ? {} : s(r, t);
}), p = f;
const k = /* @__PURE__ */ a(p);
export {
  k as default
};
